module.exports = __webpack_public_path__ + "img/liveGuided.dc64583e.svg";